import { parseAndValidateParams, getTimeUntilNextHour } from './urlValidator';

/**
 * 현재 URL에서 파라미터를 추출하여 새로운 URL에 추가
 */
export const addCurrentParamsToUrl = (url: string): string => {
  const currentParams = new URLSearchParams(window.location.search);
  const timestamp = currentParams.get('t');
  const hash = currentParams.get('h');
  
  if (timestamp && hash) {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}t=${timestamp}&h=${hash}`;
  }
  
  return url;
};

/**
 * 현재 URL의 파라미터를 URLSearchParams 형태로 반환
 */
export const getCurrentUrlParams = (): URLSearchParams | null => {
  const currentParams = new URLSearchParams(window.location.search);
  const timestamp = currentParams.get('t');
  const hash = currentParams.get('h');
  
  if (timestamp && hash) {
    return currentParams;
  }
  
  return null;
};

/**
 * 현재 URL 파라미터의 유효성을 확인
 */
export const isCurrentUrlValid = async (): Promise<boolean> => {
  const currentParams = getCurrentUrlParams();
  
  if (!currentParams) {
    return false;
  }
  
  return await parseAndValidateParams(currentParams);
};

/**
 * URL 파라미터를 검증 (세션 저장 없이)
 */
export const validateUrlParams = async (searchParams: URLSearchParams): Promise<boolean> => {
  try {
    return await parseAndValidateParams(searchParams);
  } catch (error) {
    console.error('URL 파라미터 검증 오류:', error);
    return false;
  }
};
